export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9452.588a8669.jpg";